var _circle, _circle2, _circle3, _path, _circle4, _circle5, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraphDefinitionIcon = function SvgGraphDefinitionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.409,
    cy: 13.715,
    r: 1.582,
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.245,
    cy: 8.18,
    r: 1.582,
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.082,
    cy: 13.715,
    r: 1.582,
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.8,
    d: "m4.021 9.15-1.582 3.163M8.05 12.312 6.469 9.149"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.902,
    cy: 7.915,
    r: 1.582,
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.738,
    cy: 2.38,
    r: 1.582,
    stroke: "currentColor",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.8,
    d: "M7.514 3.35 5.932 6.514M11.543 6.512 9.961 3.349"
  })));
};
export default SvgGraphDefinitionIcon;